module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Notícia")])]), _vm._v(" "), _c('NewsForm', {
    attrs: {
      "news": _vm.news,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217a9012","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/news/EditNews.vue
// module id = 699
// module chunks = 1